var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product__box"},_vm._l((_vm.items),function(item){return _c('item',{key:item.id,attrs:{"type":"catalog","item":item},on:{"add":function($event){return _vm.addCartItem(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }